import React, { useMemo } from "react";
import styled from "@emotion/styled";
import hero from "../../../assets/hero.mp4";
import { Box, Container } from "@mui/material";
import TitleUpper from "../../Components/Title";
import Paragraph from "../../Components/Paragraph";
import PurpleButton from "../../Components/PurpleButton";
import aws from '../../../assets/aws.png';
import azure from '../../../assets/azure.png';
import google from '../../../assets/google.png';
import vultr from '../../../assets/vultr.png';
import WhiteButton from "../../Components/WhiteButton/index.jsx";
const HeaderWrapper = styled.div`
  width: 100%;
  padding: 2rem 1rem;
  
  @media (min-width: 768px) {
    padding: 1rem 3rem;
  }
`;

const HeaderContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 790px;
  height: auto;
  overflow: hidden;
  border-radius: 30px;

  @media (max-width: 1200px) {
    min-height: 820px;
  }

  @media (max-width: 900px) {
    min-height: 880px;
    border-radius: 40px;
  }

  @media (max-width: 800px) {
    min-height: auto;
  }

  @media (max-width: 599px) {
    min-height: auto;
    border-radius: 24px;
  }
`;

const BackgroundVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  /* background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(88, 28, 135, 0.4) 50%,
    rgba(0, 0, 0, 0.6) 100%
  ); */
  z-index: 2;
  @media (max-width: 1550px) {
    background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(88, 28, 135, 0.4) 50%,
    rgba(0, 0, 0, 0.6) 100%
  );
  }
`;

const Content = styled.div`
  position: relative;
  z-index: 3;
  color: white;
  min-height: 760px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5rem;
  padding: 3rem 0rem 2rem 0rem;

  @media (max-width: 1200px) {
    min-height: 820px;
    gap: 4rem;
    padding: 2.5rem 0rem;
  }

  @media (max-width: 900px) {
    min-height: 880px;
    gap: 3rem;
  }

  @media (max-width: 800px) {
    min-height: auto;
    justify-content: flex-start;
    gap: 2rem;
  }

  @media (max-width: 599px) {
    min-height: auto;
    gap: 1.75rem;
    padding: 2rem 0rem;
  }
`;

const TopSection = styled.div`
  max-width: 800px;

  > .MuiTypography-root:first-of-type {
    line-height: 0.98;
    overflow: visible;
  }

  @media (max-width: 1200px) {
    max-width: 620px;

    > .MuiTypography-root:first-of-type {
      font-size: 64px;
      max-width: 620px;
    }
  }

  @media (max-width: 800px) {
    max-width: 100%;

    > .MuiTypography-root:first-of-type {
      font-size: 52px;
      line-height: 1.04;
    }
  }

  @media (max-width: 599px) {
    > .MuiTypography-root:first-of-type {
      font-size: 38px;
    }
  }
`;

const InstallButton = styled(Box)`
 @media (max-width: 600px) {
display: contents !important;
  }
`;

const ButtonRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 1.5rem;
  flex-wrap: wrap;
`;

const StatsContainer = styled.div`
  display: flex;
  align-items: flex-end;

  @media (max-width: 900px) {
    width: 100%;
    justify-content: flex-start;
  }

  @media (max-width: 599px) {
    gap: 1.25rem;
  }
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatValue = styled.div`
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 0.25rem;
  line-height: 1;
  
  @media (min-width: 768px) {
    font-size: 32px;
  }
`;

const StatLabel = styled.div`
  font-size: 12px;
  opacity: 0.8;
`;

const BottomSection = styled.div`
  width: 100%;

  @media (max-width: 800px) {
    margin-top: 1rem;
  }
`;

const BottomContent = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 2rem;

  @media (max-width: 1100px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 1.5rem;
  }
`;

const PoweredByBlock = styled.div`
  min-width: 0;
`;

const LogosContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1200px) {
    gap: 1.25rem;
  }
`;

const LogoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.9;
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }
`;
const StatValueline = styled.div`
  font-size: 1rem;
  /* font-weight: 700; */
  margin-top: 10px;
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
`;
const getRefreshCount = (min, max) => `${Math.floor(Math.random() * (max - min + 1)) + min}K+`;


const Header = () => {
 const isMobile = window.innerWidth <= 600;
 const stats = useMemo(() => ({
  downloads: getRefreshCount(8, 15),
  activeUsers: getRefreshCount(3, 9),
 }), []);

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <BackgroundVideo src={hero} autoPlay loop muted playsInline />
        <Overlay />
        <Container maxWidth='xl'>
        <Content>
          <TopSection>
            <TitleUpper>
              Privacy
              Infrastructure for
              the Multichain
               Internet
            </TitleUpper>
            <Paragraph style={{maxWidth:'630px'}}>
            Shadow Node powers encrypted communication, private access, and censorship resistant networking through a unified privacy ecosystem built on $SVPN.
            </Paragraph>
            <Box style={{maxWidth:'650px'}} >
              <InstallButton>
                <ButtonRow>
                  <PurpleButton href="#shadowecosystem" style={{ fontSize: '16px', padding: '6px 18px' }}>
                    Explore Ecosystem
                  </PurpleButton>
                  <WhiteButton  style={{ fontSize: '16px', padding: '6px 18px' }}>
                    View Network
                  </WhiteButton>
                </ButtonRow>
              </InstallButton>
            </Box>
          </TopSection>
          
          <BottomSection>
            <BottomContent>
              <PoweredByBlock>
                <TitleUpper style={{fontSize:'25px'}}>Powered by</TitleUpper>
                <LogosContainer>
                  <LogoItem>
                    <img src={aws} style={{width:'100%',height:'auto', maxWidth: isMobile ? '34px' : '60px'}}/>
                    <Paragraph style={{marginBottom:'0px',fontSize:'15px'}}>Amazon Web<br/>Service</Paragraph>
                  </LogoItem>
                  <LogoItem>
                    <img src={azure} style={{width:'100%',height:'auto',maxWidth: isMobile ? '34px' : '60px'}}/>
                    <Paragraph style={{marginBottom:'0px',fontSize:'15px'}}>Microsoft<br/>Azure</Paragraph>
                  </LogoItem>
                  <LogoItem>
                  <img src={google} style={{width:'100%',height:'auto',maxWidth: isMobile ? '34px' : '60px'}}/>
                    <Paragraph style={{marginBottom:'0px',fontSize:'15px'}}>Google<br/>Cloud</Paragraph>
                  </LogoItem>
                  <LogoItem>
                    <img src={vultr} style={{width:'100%',height:'auto',maxWidth: isMobile ? '34px' : '60px'}}/>
                    <Paragraph style={{marginBottom:'0px',fontSize:'15px'}}>Vultr<br/>Servers</Paragraph>
                  </LogoItem>
                </LogosContainer>
              </PoweredByBlock>
              <StatsContainer style={{ display: 'flex', gap: '25px' }}>
            <StatItem>
            <StatValue>11.2K+</StatValue>
            <StatLabel>Downloads</StatLabel>
            </StatItem>
            <StatItem>
            <StatValueline style={{fontWeight:'normal'}} >|</StatValueline>
            </StatItem>
            <StatItem>
            <StatValue>6.8k+
            </StatValue>
            <StatLabel>Active Users</StatLabel>
            </StatItem>
        </StatsContainer>
            </BottomContent>
          </BottomSection>
        </Content>
        </Container>
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;
